<template>
	<div class="bg_content">
		<div>
			<span style="color: #b2b2b2">门禁管理 /</span>
			<span style="color: #5c5c5c"> 紧急开关门记录</span>
		</div>
		<div class="content_body">
			<el-card shadow="never" style="height: 80px;">
				<el-row :gutter="24">
					<el-col :span="4">
						<el-input placeholder="设备名称、SN序列号" v-model="searchQuery.deviceLikeString" clearable></el-input>
					</el-col>
					<el-col :span="5">
						<el-input placeholder="姓名、员工工号、设备工号、电话" v-model="searchQuery.likeString" clearable></el-input>
					</el-col>
					<el-col :span="5">
						<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
					</el-col>
					<el-col :span="10" style="text-align: right;">
						<el-button type="warning" icon="el-icon-back" @click="$router.replace('/emergencyOpenDoor')">
							返回</el-button>
					</el-col>
				</el-row>
			</el-card>
			<el-card shadow="never" class="card_table">
				<el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}" height="580">
					<template slot="empty">
						<div>
							<img src="@/assets/nodata.png" class="nodata" />
							<div>无数据</div>
						</div>
					</template>
					<el-table-column label="设备名称">
						<template slot-scope="scope" v-show="scope.row.device.name">
							{{scope.row.device.name}}
						</template>
					</el-table-column>
					<el-table-column label="SN序列号" prop="deviceSn" />
					<el-table-column label="操作人" >
						<template slot-scope="scope" v-show="scope.row.user.name">
							{{scope.row.user.name}}
						</template>
					</el-table-column>
          <el-table-column label="开关门方式" >
            <template slot-scope="scope">
              <el-tag size="small" v-if="scope.row.controlWay===0" type="success">自动控制</el-tag>
              <el-tag size="small" v-if="scope.row.controlWay===1" type="danger">开门</el-tag>
              <el-tag size="small" v-if="scope.row.controlWay===2" type="warning">关门</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" >
            <template slot-scope="scope">
              <el-tag size="small" v-if="scope.row.status===0" type="success">成功</el-tag>
              <el-tag size="small" v-if="scope.row.status===-1" type="danger">失败</el-tag>
              <el-tag size="small" v-if="scope.row.status===1" type="warning">下发中</el-tag>
            </template>
          </el-table-column>
					<el-table-column label="手机号" >
						<template slot-scope="scope" v-show="scope.row.user.phone">
							{{scope.row.user.phone}}
						</template>
					</el-table-column>
					<el-table-column label="设备工号" >
						<template slot-scope="scope" v-show="scope.row.user.deviceNumber">
							{{scope.row.user.deviceNumber}}
						</template>
					</el-table-column>
					<el-table-column label="员工工号" >
						<template slot-scope="scope" v-show="scope.row.user.jobNumber">
							{{scope.row.user.jobNumber}}
						</template>
					</el-table-column>
					<el-table-column label="开门时间" prop="createTime" width="180"/>
				</el-table>
				<el-pagination v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
					layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
			</el-card>
		</div>
		<company-footer-info />
	</div>
</template>

<script>
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
	import {
    EmergencyOpenDoorApi
	} from "@/api/nexus/emergencyOpenDoor";
	export default {
		components: {
			CompanyFooterInfo
		},
		data() {
			return {
				searchQuery: {
					pageNum: 1,
					pageSize: 20,
					deviceLikeString: '',
					likeString: ''
				},
				tableData: [],
				tableTotal: 0,

			}
		},
		methods: {
			handleSearch() {
				this.searchQuery.pageNum = 1;
				this.getList();
			},
			handleCurrentChange(page) {
				this.searchQuery.pageNum = page;
				this.getList();
			},
			async getList() {
				let {
					code,
					data
				} = await EmergencyOpenDoorApi.queryEmergencyOpenDoorPage(this.searchQuery);
				this.tableData = data.list;
				this.tableTotal = data.total;
			},
		},
		mounted() {
			this.getList();
		}
	}
</script>

<style>
	.bg_content {
		width: 100%;
		padding: 16px 20px;
		background: #f4f7fc;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.content_body {
		margin-top: 20px;
		height: 100%;
	}

	.card_table {
		height: calc(100% - 80px) !important;
	}
</style>